import { useShowCollapsibleMenuAlert } from '@/components/header/NewFeatureDialog/useShowCollapsibleMenuAlert';
import { TourProvider as ReactTourProvider } from '@reactour/tour';
import type { ReactNode } from 'react';

/**
 * React Tour Provider with custom design
 * @param props - React node
 * @returns TourProvider
 */
export function TourProvider({ children }: { children: ReactNode }) {
  const { handleDismissAlert } = useShowCollapsibleMenuAlert();
  return (
    <ReactTourProvider
      showCloseButton={false}
      steps={[]}
      styles={{
        popover: (base) => ({
          ...base,
          maxWidth: '600px',
          background: 'rgb(222, 222, 222)',
          borderRadius: 10,
        }),
        maskArea: (base) => ({ ...base, rx: 10 }),
        arrow: (base) => ({
          ...base,
          width: '2rem',
          height: '2rem',
        }),
      }}
      onClickMask={({ setCurrentStep, currentStep, steps, setIsOpen }) => {
        if (steps) {
          if (currentStep === steps.length - 1) {
            setIsOpen(false);
          }
          setCurrentStep((s) => (s === steps.length - 1 ? 0 : s + 1));
        }
      }}
      disableInteraction
      beforeClose={(element) => {
        // dismiss collapsibleMenu tour
        if (element?.getAttribute('data-testid') === 'MenuOpenIcon') {
          handleDismissAlert();
        }
      }}
    >
      {children}
    </ReactTourProvider>
  );
}
